import React from "react";
import "./SectorsSection.css";

const PantryTrustSection = () => {
  const sectors = [
   "Corporate Offices",
  "IT Companies",
  "Financial Institutions",
  "Law Firms",
  "Consulting Firms",
  "Educational Institutions",
  "Training Centers",
  "Guest Houses",
  "Serviced Apartments",
  "Co-working Spaces",
  "Government Offices",
  "NGOs & Non-Profits"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PantryTrustSection;
